import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

export interface PushSubscriptionRequest {
    Endpoint: string;
    P256DH: string;
    Auth: string;
    Login?: string;
    Role?: string;
}

export class WebPushController {
    async saveSubscription(subscription: PushSubscriptionJSON, login?: string, role?: string) {
        const payload: PushSubscriptionRequest = {
            Endpoint: subscription.endpoint || '',
            P256DH: subscription.keys?.p256dh || '',
            Auth: subscription.keys?.auth || '',
            Login: login,
            Role: role
        };
        const response = await server.post(`${BACKEND_URL}/webpush/subscribe`, payload);
        return response.data;
    }

    async unsubscribe(endpoint?: string, login?: string) {
        let endpointToUse = endpoint;
        if (!endpointToUse && 'serviceWorker' in navigator) {
            try {
                const registration = await navigator.serviceWorker.ready;
                const subscription = await registration.pushManager.getSubscription();
                if (subscription) {
                    endpointToUse = subscription.endpoint;
                }
            } catch (error) {
                console.error('Error getting subscription endpoint:', error);
            }
        }

        if (!endpointToUse) {
            throw new Error('No subscription endpoint found');
        }

        if (!login) {
            throw new Error('Login is required for unsubscribe');
        }
        const response = await server.post(`${BACKEND_URL}/webpush/unsubscribe`, {
            endpoint: endpointToUse,
            login: login
        });
        return response.data;
    }

    async getVapidPublicKey() {
        const response = await server.get(`${BACKEND_URL}/webpush/vapidPublic`);
        return response.data;
    }
}
